import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { STORAGE_PURPOSES, userStoragePath } from '@/utils/storagePaths';

/**
 * Uploads a user's photo (a JPEG blob, from AvatarImagePicker) to their profile folder,
 * where the CRM's profile editor puts it, and returns its download URL for their imageUrl.
 * Folio admins can write to any user's folder (storage.rules).
 */
export const uploadUserPhoto = async (userId, blob) => {
	const storageRef = ref(
		getStorage(),
		userStoragePath(userId, STORAGE_PURPOSES.profile, 'profile.jpg'),
	);
	await uploadBytes(storageRef, blob);
	return getDownloadURL(storageRef);
};
